import React from "react";
import DataManagerMissingCivicNumberDialog from "../components/DataManagerMissingCivicNumberDialog.jsx";
import { addressHasCivicNumber, normalizeOptionalString } from "./useDataManagerOrdersUtils.js";

export default function useMissingCivicNumberConfirmation() {
  const resolverRef = React.useRef(null);
  const [dialogState, setDialogState] = React.useState(null);

  const requestMissingCivicNumberConfirmation = React.useCallback((address) => {
    const normalizedAddress = normalizeOptionalString(address);
    if (!normalizedAddress || addressHasCivicNumber(normalizedAddress)) {
      return Promise.resolve(true);
    }

    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setDialogState({ address: normalizedAddress });
    });
  }, []);

  const handleConfirm = React.useCallback(() => {
    resolverRef.current?.(true);
    resolverRef.current = null;
    setDialogState(null);
  }, []);

  const handleCancel = React.useCallback(() => {
    resolverRef.current?.(false);
    resolverRef.current = null;
    setDialogState(null);
  }, []);

  const missingCivicNumberDialog = dialogState ? (
    <DataManagerMissingCivicNumberDialog
      address={dialogState.address}
      isOpen
      onCancel={handleCancel}
      onConfirm={handleConfirm}
    />
  ) : null;

  return {
    missingCivicNumberDialog,
    requestMissingCivicNumberConfirmation,
  };
}
